import React, { useEffect, useState } from "react"
import { api, json } from "../api"

export function GroupMeCallbackPage() {
  const [message, setMessage] = useState("Finishing your GroupMe connection…")
  const [returnTo, setReturnTo] = useState("/teams")

  useEffect(() => {
    const queryParams = new URLSearchParams(window.location.search)
    const hashParams = new URLSearchParams(window.location.hash.slice(1))
    const accessToken = queryParams.get("access_token") || hashParams.get("access_token")
    const oauthError = queryParams.get("error_description") || hashParams.get("error_description") || queryParams.get("error") || hashParams.get("error")
    const teamId = window.sessionStorage.getItem("groupme_oauth_team_id")
    const teamPath = teamId ? `/teams/${encodeURIComponent(teamId)}?tab=messages` : "/teams"
    setReturnTo(teamPath)
    window.history.replaceState({}, "", "/groupme/callback")
    window.sessionStorage.removeItem("groupme_oauth_team_id")

    if (!accessToken || !teamId) {
      setMessage(oauthError ? `GroupMe authorization was not completed: ${oauthError}` : "GroupMe did not return a usable connection. Return to the team and try again.")
      return
    }

    api(`/teams/${encodeURIComponent(teamId)}/groupme_setting/upsert`, json("PUT", { groupme_setting: { access_token: accessToken } }))
      .then(() => { window.location.replace(`${teamPath}&groupme=connected`) })
      .catch(error => setMessage(error.message || "GroupMe could not be connected."))
  }, [])

  return <main className="error-fallback"><p className="eyebrow">GroupMe OAuth</p><h1>Connecting your account</h1><p>{message}</p><a className="button button--secondary" href={returnTo}>Return to team</a></main>
}
